import React from "react";
import { cn } from "../../../utils/tw";

const SecondaryButton: React.FC<
  React.ButtonHTMLAttributes<HTMLButtonElement>
> = ({ className, children, ...props }) => (
  <button
    {...props}
    className={cn(
      'bg-transparent border-2 border-ds-neutral-300 text-text-secondary font-semibold px-6 py-3 rounded-xl',
      'hover:bg-bg-hover dark:hover:bg-ds-neutral-800/20 transition-all duration-200',
      'focus:outline-none focus:ring-4 focus:ring-ds-primary-500/30',
      'disabled:opacity-60 disabled:cursor-not-allowed',
      'flex items-center justify-center gap-2 min-h-[44px]',
      className
    )}
  >
    {children}
  </button>
);

export default SecondaryButton;
